export const masterMessageGroup = {
  groupType: {
    crm: "CRM Message",
    template: "Template",
  },
};
